import { gql } from "@apollo/client";

export default gql`
	query ($country: String!) {
		taxCodeByCountry(country: $country) {
			taxCode
		}
	}
`;
